import api from '../lib/api'

export const listContacts = (tenantId, params = {}) =>
  api.get(`/manager/${tenantId}/contacts`, { params }).then(r => r.data)

export const exportContactsCsv = (tenantId, params = {}) =>
  api.get(`/manager/${tenantId}/contacts/export`, {
    params,
    responseType: 'blob',
  })

export const getContact = (tenantId, contactId) =>
  api.get(`/manager/${tenantId}/contacts/${contactId}`).then(r => r.data)

export const patchContact = (tenantId, contactId, body) =>
  api.patch(`/manager/${tenantId}/contacts/${contactId}`, body).then(r => r.data)

export const deleteContact = (tenantId, contactId) =>
  api.delete(`/manager/${tenantId}/contacts/${contactId}`).then(r => r.data)

export const getContactConversations = (tenantId, contactId) =>
  api.get(`/manager/${tenantId}/contacts/${contactId}/conversations`).then(r => r.data)

export const getContactBookingHistory = (tenantId, contactId, params = {}) =>
  api.get(`/manager/${tenantId}/contacts/${contactId}/bookings`, { params }).then(r => r.data)

export const createContact = (tenantId, body) =>
  api.post(`/manager/${tenantId}/contacts`, body).then(r => r.data)

export const bulkCreateContacts = (tenantId, contacts) =>
  api.post(`/manager/${tenantId}/contacts/bulk`, { contacts }).then(r => r.data)

export const addContactRelation = (tenantId, contactId, body) =>
  api.post(`/manager/${tenantId}/contacts/${contactId}/relations`, body).then(r => r.data)

export const removeContactRelation = (tenantId, contactId, relatedContactId) =>
  api.delete(`/manager/${tenantId}/contacts/${contactId}/relations/${relatedContactId}`).then(r => r.data)
